import { Injectable } from '@angular/core';

import { ClientInterface } from '../data';
import { MemoryMapCacheRepository } from './memory-map-cache.repository';

@Injectable()
export class ClientCacheRepository extends MemoryMapCacheRepository<ClientInterface> {
    getKey(docId: string): string {
        return 'ClientCacheRepository' + docId;
    }
}
